import { render } from "./FoerderfinderCategoryButton.pug?vue&type=template&id=2935f54f&lang=pug"
import script from "./FoerderfinderCategoryButton.js?vue&type=script&lang=js"
export * from "./FoerderfinderCategoryButton.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__